//Modal for editing a protectee
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import CloseIcon from '@mui/icons-material/Close';
import './managedAccountModal.scss';
import './modalMain.scss';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';


export const ManagedAccount = ({ isOpen, onClose, id_num, editName, editDob, editRace, editGender, editLocation, editPhoto, editMainAccount }) => {
    //  Need to build out the form to accurately reflect the inputs and values needed. then need to connect the edit function to the backend. 
    //   console.log('edit account opened')
    // const [groupName,setGroupName] = useState('') 
    // let groupName = "test";
    const [edit_name, setName] = useState('None Specified');
    const [edit_dob, setDob] = useState('None Specified');
    const [edit_race, setRace] = useState('None Specified');
    const [edit_gender, setGender] = useState('none');
    const [edit_location, setLocation] = useState('None Specified');
    const [edit_photoUrl, setPhotoUrl] = useState('None Specified');
    const [edit_mainAccount, setMainAccount] = useState('None Specified');
    const [userToken, setUserToken] = useState(null);
    const navigate = useNavigate();

    const getUserToken = async () => {
        try {
            const session = await fetchAuthSession();
            const access_token = session.tokens.accessToken.toString();
            // console.log('Access Tokens',access_token);
            setUserToken(access_token);
            return access_token
        } catch {
            navigate("/login")
        }
    };

    useEffect(() => {
        getUserToken();
    }, []);

    useEffect(() => {
        setName(editName);
        setDob(editDob);
        setRace(editRace);
        setGender(editGender);
        setLocation(editLocation);
        setPhotoUrl(editPhoto);
        setMainAccount(editMainAccount);
    }, [isOpen, onClose]);

    const handleDelete = async (e) => {
        e.preventDefault();

        alert("Warning, this action is permanent and will affect the data collected by the Weathervane App.");

        const formData = {
            id_num,
            edit_name,
            edit_dob,
            edit_race,
            edit_gender,
            edit_location,
            edit_photoUrl,
            edit_mainAccount,
            userToken
        };

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/deletemanagedaccount", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
                // Redirect unauthorized user to login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                console.warn("API Error:", response.status, response.statusText);
                return;
            }

            // Only close modal if delete succeeded
            onClose();

        } catch (err) {
            console.error("Network or fetch error:", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            id_num,
            edit_name,
            edit_dob,
            edit_race,
            edit_gender,
            edit_location,
            edit_photoUrl,
            edit_mainAccount,
            userToken
        };

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/editmanagedaccount", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
                // Redirect unauthorized user to login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                console.warn("API Error:", response.status, response.statusText);
                return;
            }

            // Only close modal if edit succeeded
            onClose();

        } catch (err) {
            console.error("Network or fetch error:", err);
        }
    };

    if (!isOpen) {
        return null
    } else {
        if (userToken === null) {
            return (
                <div className="loadingdiv">
                    <h1>...Loading...</h1>
                </div>
            )
        } else {
            return ReactDOM.createPortal(
                <div className='modalMainContainer'>
                    <div className='modalContainer'>
                        <div className="mainPage">
                            <div className="modalheader">
                                <div className="left">
                                    <h1>Edit Account Details:</h1>
                                </div>
                                <div className="right" onClick={onClose}>
                                    <button><CloseIcon /></button>
                                </div>

                            </div>
                            <div className="groupform">
                                <form onSubmit={handleSubmit}>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Name</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Name"
                                                defaultValue={editName}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Date of Birth</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Date of Birth"
                                                defaultValue={editDob}
                                                onChange={(e) => setDob(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Location</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Location"
                                                defaultValue={editLocation}
                                                onChange={(e) => setLocation(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Photo Url</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="photourl"
                                                defaultValue={editPhoto}
                                                maxLength={255}
                                                onChange={(e) => setPhotoUrl(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Race</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setRace(e.target.value)}>
                                                <option defaultValue={editRace}>{editRace}</option>
                                                <option Value="None">None</option>
                                                <option value="Black">Black</option>
                                                <option value="White">White</option>
                                                <option value="Asian">Asian</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Gender</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setGender(e.target.value)}>
                                                <option defaultValue={editGender}>{editGender}</option>
                                                <option Value="None">None</option>
                                                <option value="male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Main Account</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setMainAccount(e.target.value)}>
                                                <option defaultValue={editMainAccount}>{editMainAccount}</option>
                                                <option Value="No">No</option>
                                                <option value="Yes">Yes</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="submitbutton">
                                <button onClick={handleSubmit}>Save Account Information</button>
                            </div>
                            <div className="deletebutton">
                                <button onClick={handleDelete}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div>,
                document.getElementById("portal")
            )
        }
    }
}
